import { Redirect, Route } from "react-router-dom";
import { useAuth } from "../services/AuthContext";

const PrivateRoute = ({ component: Component, children, render, ...rest }) => {
  const { currentUser } = useAuth();
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!currentUser) {
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location },
              }}
            />
          );
        }

        if (typeof render === "function") {
          return render(props);
        }

        if (Component) {
          return <Component {...props} />;
        }

        if (typeof children === "function") {
          return children(props);
        }

        return children || null;
      }}
    />
  );
};

export default PrivateRoute;
